export enum FeedbackEnum {
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  POOR = 'POOR',
  VERY_POOR = 'VERY POOR',
}

export interface AddFeedbackRequest {
  type: FeedbackEnum;
  comment: string;
}

export interface Feedback {
  id: string;
  userId: string;
  type: FeedbackEnum;
  comment: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}
